import { render, staticRenderFns } from "./people-filter.vue?vue&type=template&id=772dfca5&scoped=true"
import script from "./people-filter.vue?vue&type=script&lang=js"
export * from "./people-filter.vue?vue&type=script&lang=js"
import style0 from "./people-filter.vue?vue&type=style&index=0&id=772dfca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772dfca5",
  null
  
)

export default component.exports